import PublicSiteLayout from "@/components/layouts/PublicSiteLayout";
import ArticleDetail from "./ArticleDetail";

const PublicArticleDetail = () => {
  return (
    <PublicSiteLayout>
      <ArticleDetail mode="public" withDashboard={false} />
    </PublicSiteLayout>
  );
};

export default PublicArticleDetail;
